import { RoleID } from "src/utils/enum/role.enum";
import { CoreMenuItem } from "./core-menu";
import { DEMO } from "src/app/config/brand.config";

export const SYSTEM_NAVIGATION_MENU: CoreMenuItem[] = [
  //Component menu
  // {
  //   id: "",
  //   title: "MENU.HOME",
  //   url: "/home",
  //   icon: "note",
  //   type: "item",
  // },
  //Dashboard menu
  // {
  //   id: "",
  //   title: "MENU.DASHBOARD",
  //   url: "/dashboard",
  //   icon: "element-11",
  //   type: "item",
  // },
  // --- signed in ------------------------------------------------------------
  // A student's own three screens come FIRST, before the catalogue and the
  // marketing pages. They were appended at the end, which is the order a
  // visitor needs, not the order a member does: once you have signed in, the
  // classroom and your practice are what you came back for, and "about us" is
  // not. Kept as one contiguous group so the nav does not read as two
  // unrelated halves.
  {
    id: "",
    title: "MENU.ONLINE_CLASS",
    url: "/online-class",
    icon: "element-11",
    type: "item",
    role: [RoleID.MEMBER],
  },
  // The quiz list had no way in. /online-class/quiz existed, the API served it
  // correctly, and the only routes that linked to it were the two profile
  // report screens and the section at the bottom of a course page — so a
  // student had to already know the feature existed to find it. That is fatal
  // for a course sold as quizzes only: there is no video page to scroll to the
  // bottom of.
  //TODO wait for v2.1 feature


  // --- the parent's half of the product ---------------------------------------
  // Three screens that existed, worked, and had no link to them anywhere: a
  // parent signed in and got the same nav as a visitor. They are what a parent
  // comes here to do — see how their child is getting on, hand out the courses
  // they bought, and manage who is in their care. Buying MORE is the ordinary
  // catalogue below, which is why there is no fourth entry for it.
  {
    id: "",
    title: "MENU.PARENT_MONITOR",
    url: "/profile/monitor",
    icon: "element-11",
    type: "item",
    role: [RoleID.PARENT],
  },
  {
    id: "",
    title: "MENU.PARENT_COURSES",
    url: "/profile/parent-courses",
    icon: "element-11",
    type: "item",
    role: [RoleID.PARENT],
  },
  {
    id: "",
    title: "MENU.PARENT_STUDENTS",
    url: "/profile/student",
    icon: "element-11",
    type: "item",
    role: [RoleID.PARENT],
  },

  {
    id: "",
    title: "MENU.COURSES",
    url: "/courses",
    icon: "element-11",
    type: "item",
  },
  {
    id: "",
    title: "MENU.BLOG",
    url: "/blogs",
    icon: "element-11",
    type: "item",
  },
  // The manual documents THIS build — the seeded accounts, the simulated
  // checkout, and screenshots taken from the demo app itself — so it ships only
  // when demo mode is on. A customer build (`environment.demo` unset) drops it
  // from the nav entirely, and its routes 404 like any other unknown URL.
  ...(DEMO.enabled
    ? ([
      {
        id: "",
        title: "QUIZ.TITLE",
        url: "/online-class/quiz",
        icon: "element-11",
        type: "item",
        role: [RoleID.MEMBER],
      },
      // The analysis, in the nav rather than buried in the profile. A student who
      // has just done ten questions should be one click from what they mean.
      {
        id: "",
        title: "QUIZ.MY_SKILLS",
        url: "/online-class/skills",
        icon: "element-11",
        type: "item",
        role: [RoleID.MEMBER],
      },

      {
        id: "",
        title: "MENU.MANUAL",
        url: "/manual",
        icon: "book-open",
        type: "accordion",
        children: [
          {
            id: "",
            title: "MENU.MANUAL_READ",
            url: "/manual",
            icon: "book-open",
            type: "item",
          },
          {
            id: "",
            title: "MENU.MANUAL_VIDEO",
            url: "/manual/video",
            icon: "youtube",
            type: "item",
          },
        ],
      },
    ] as CoreMenuItem[])
    : []),
  {
    id: "",
    title: "MENU.ABOUT_US",
    url: "/about-us",
    icon: "element-11",
    type: "item",
  },
  // //Layout Builder menu
  // {
  //   id: "",
  //   title: "Layout Builder",
  //   url: "/builder",
  //   icon: "switch",
  //   type: "item",
  // },
  // //Crafted section
  // {
  //   id: "",
  //   title: "Crafted",
  //   url: "/crafted",
  //   icon: "",
  //   type: "section",
  //   children: [
  //     {
  //       id: "",
  //       title: "Pages",
  //       icon: "element-plus",
  //       url: "/crafted/pages",
  //       type: "accordion",
  //       children: [
  //         {
  //           id: "",
  //           title: "Profile",
  //           icon: "",
  //           url: "/crafted/pages/profile",
  //           type: "accordion",
  //           children: [
  //             {
  //               id: "",
  //               title: "Overview",
  //               icon: "",
  //               url: "/crafted/pages/profile/overview",
  //               type: "item",
  //             },
  //             {
  //               id: "",
  //               title: "Projects",
  //               icon: "",
  //               url: "/crafted/pages/profile/projects",
  //               type: "item",
  //             },
  //             {
  //               id: "",
  //               title: "Campaigns",
  //               icon: "",
  //               url: "/crafted/pages/profile/campaigns",
  //               type: "item",
  //             },
  //             {
  //               id: "",
  //               title: "Documents",
  //               icon: "",
  //               url: "/crafted/pages/profile/documents",
  //               type: "item",
  //             },
  //             {
  //               id: "",
  //               title: "Connections",
  //               icon: "",
  //               url: "/crafted/pages/profile/connections",
  //               type: "item",
  //             },
  //           ],
  //         },
  //         {
  //           id: "",
  //           title: "Wizards",
  //           icon: "",
  //           url: "/crafted/pages/wizards",
  //           type: "accordion",
  //           children: [
  //             {
  //               id: "",
  //               title: "Horizontal",
  //               icon: "",
  //               url: "/crafted/pages/wizards/horizontal",
  //               type: "item",
  //             },
  //             {
  //               id: "",
  //               title: "Vertical",
  //               icon: "",
  //               url: "/crafted/pages/wizards/vertical",
  //               type: "item",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       id: "",
  //       title: "Accounts",
  //       icon: "profile-circle",
  //       url: "/crafted/account",
  //       type: "accordion",
  //       children: [
  //         {
  //           id: "",
  //           title: "Overview",
  //           icon: "",
  //           url: "/crafted/account/overview",
  //           type: "item",
  //         },
  //         {
  //           id: "",
  //           title: "Settings",
  //           icon: "",
  //           url: "/crafted/account/settings",
  //           type: "item",
  //         },
  //       ],
  //     },
  //     {
  //       id: "",
  //       title: "Widgets",
  //       icon: "element-7",
  //       url: "/crafted/widgets",
  //       type: "accordion",
  //       children: [
  //         {
  //           id: "",
  //           title: "Lists",
  //           icon: "",
  //           url: "/crafted/widgets/lists",
  //           type: "item",
  //         },
  //         {
  //           id: "",
  //           title: "Statistics",
  //           icon: "",
  //           url: "/crafted/widgets/statistics",
  //           type: "item",
  //         },
  //         {
  //           id: "",
  //           title: "Charts",
  //           icon: "",
  //           url: "/crafted/widgets/charts",
  //           type: "item",
  //         },
  //         {
  //           id: "",
  //           title: "Mixed",
  //           icon: "",
  //           url: "/crafted/widgets/mixed",
  //           type: "item",
  //         },
  //         {
  //           id: "",
  //           title: "Tables",
  //           icon: "",
  //           url: "/crafted/widgets/tables",
  //           type: "item",
  //         },
  //         {
  //           id: "",
  //           title: "Feeds",
  //           icon: "",
  //           url: "/crafted/widgets/feeds",
  //           type: "item",
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   id: "",
  //   title: "App",
  //   url: "/app",
  //   icon: "",
  //   type: "section",
  //   children: [
  //     //Chat menu
  //     {
  //       id: "",
  //       title: "Chat",
  //       icon: "message-text-2",
  //       url: "/apps/chat",
  //       type: "accordion",
  //       children: [
  //         {
  //           id: "",
  //           title: "Private Chat",
  //           icon: "",
  //           url: "/apps/chat/private-chat",
  //           type: "item",
  //           children: [],
  //         },
  //         {
  //           id: "",
  //           title: "Group Chat",
  //           icon: "",
  //           url: "/apps/chat/group-chat",
  //           type: "item",
  //           children: [],
  //         },
  //         {
  //           id: "",
  //           title: "Drawer Chat",
  //           icon: "",
  //           url: "/apps/chat/drawer-chat",
  //           type: "item",
  //           children: [],
  //         },
  //       ],
  //     },
  //     {
  //       id: "",
  //       title: "User Management",
  //       icon: "profile-user",
  //       url: "/apps/users",
  //       type: "accordion",
  //       children: [
  //         {
  //           id: "",
  //           title: "Users",
  //           icon: "",
  //           url: "/apps/users",
  //           type: "item",
  //           children: [],
  //         },
  //         {
  //           id: "",
  //           title: "Roles",
  //           icon: "",
  //           url: "/apps/roles",
  //           type: "item",
  //           children: [],
  //         },
  //         {
  //           id: "",
  //           title: "Permissions",
  //           icon: "",
  //           url: "/apps/permissions",
  //           type: "item",
  //           children: [],
  //         },
  //       ],
  //     },
  //   ],
  // },
];
